export default "* Fart\n* Balance\n* Koncentration\n";